export enum DotNetFormulaErrorCodesEnum {
	NotInitialized = 1,
	FormulaIsEmptyOrNull = 2,
	NoColumnsOrValues = 3,
	FormulaSyntaxIssue = 4,
	FormulaExecutionFailed = 5,
	MiscellaneousError = 6,
	UnknownError = 7,
	FormulaExecutionFailedNaN = 8
}
